// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1ztbW","footer":"Form_footer__2rCX-"};